import { FieldsTypes } from "../consts/index.js";
import { Typography } from "@mui/material";

const getAllSeatsTicketsInfo = (chosenTickets) => {
    const finalTicketInfo = { seats: [] }
    const ticketsIds = Object.keys(chosenTickets)
    for (const ticketId of ticketsIds) {
        const ticketInfo = chosenTickets[ticketId].info
        if (!ticketInfo.seats) {
            continue
        }
        ticketInfo.seats = ticketInfo.seats.map(seat => ({ ...seat, nimiTicketId: ticketId }))
        finalTicketInfo.seats.push(...ticketInfo.seats)
    }
    return finalTicketInfo
}

export const generateInitialOrderDetailsState = (eventTickets, chosenTickets, oneBuyerDetails, customQuestions, initialUserEventDetails, pricePerTicket) => {

    const initialState = []
    const summary = []
    let totalToPayLocal = 0 // Use for backup in case of failure from backend
    let nimiFeeLocal = 0 // Use for backup in case of failure from backend
    const ticketsIds = Object.keys(chosenTickets)
    for (const ticketId of ticketsIds) {
        const amountOfOrdersPerTickets = chosenTickets[ticketId].amount
        const ticketInfo = chosenTickets[ticketId].info

        if (amountOfOrdersPerTickets) {
            const relevantTicket = eventTickets.find(ticket => ticket._id == ticketId)

            for (let i = 0; i < amountOfOrdersPerTickets; i++) {
                if (relevantTicket.nimiFee || !nimiFeeLocal) {
                    nimiFeeLocal = relevantTicket.nimiFee
                }
                const summaryRow = {
                    ticketName: relevantTicket.name,
                    ticketId: relevantTicket._id,
                    totalPrice: relevantTicket.price,
                    priceLevel: relevantTicket.priceLevel,
                    amount: 1,
                    index: i,
                    ticketInfo,
                }
                totalToPayLocal += relevantTicket.price
                summary.push(summaryRow)

                if (oneBuyerDetails && initialState.length === 1) {
                    continue
                }

                const isFirstRow = initialState.length === 0

                const singleUserEventInitialState = {
                    fname: (isFirstRow && initialUserEventDetails?.fname) ? initialUserEventDetails.fname : '',
                    lname: (isFirstRow && initialUserEventDetails?.lname) ? initialUserEventDetails.lname : '',
                    phone: (isFirstRow && initialUserEventDetails?.phone) ? initialUserEventDetails.phone : '',
                    email: (isFirstRow && initialUserEventDetails?.email) ? initialUserEventDetails.email : '',
                    social_link: (isFirstRow && initialUserEventDetails?.fbProfile) ? initialUserEventDetails.fbProfile : '',
                    gender: (isFirstRow && initialUserEventDetails?.gender) ? initialUserEventDetails.gender : '',
                    birth_date: (isFirstRow && initialUserEventDetails?.birth_date) ? initialUserEventDetails.birth_date : null,
                    businessCode: (isFirstRow && initialUserEventDetails?.businessCode) ? initialUserEventDetails.businessCode : '',
                    businessName: (isFirstRow && initialUserEventDetails?.businessName) ? initialUserEventDetails.businessName : '',
                    ticketName: relevantTicket.name,
                    ticketId: relevantTicket._id,
                    ticketInfo: oneBuyerDetails ? getAllSeatsTicketsInfo(chosenTickets) : ticketInfo,
                    isAllowMarketingDelivery: (isFirstRow && initialUserEventDetails?.isAllowMarketingDelivery) ? initialUserEventDetails.isAllowMarketingDelivery : true,
                }

                if (customQuestions?.length) {
                    for (const customQ of customQuestions) {
                        switch (customQ.custom_type) {
                            case FieldsTypes.STRING:
                                singleUserEventInitialState[customQ.custom_name] = ""
                                break
                            case FieldsTypes.DATE_NO_TIME:
                                singleUserEventInitialState[customQ.custom_name] = null
                                break
                            case FieldsTypes.YES_OR_NO:
                                singleUserEventInitialState[customQ.custom_name] = false
                                break
                        }
                    }
                }

                initialState.push(singleUserEventInitialState)
            }
        }
    }
    return { initialState, summary, totalToPayLocal, nimiFeeLocal }
}
export const getTotalTicketsNumber = (chosenTickets) => {
    let totalAmountOfTickets = 0
    const ticketsIds = Object.keys(chosenTickets)
    for (const ticketId of ticketsIds) {
        totalAmountOfTickets += chosenTickets[ticketId] ? chosenTickets[ticketId].amount : 0
    }
    return totalAmountOfTickets
}

export const getSeatLabel = (row) => {
    const seats = row?.ticketInfo?.seats
    if (seats && seats[row.index]) {
        const seatInfo = seats[row.index]

        return (
            <>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    {seatInfo.seatLabel}
                </Typography>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    {seatInfo.rowLabel ? seatInfo.rowLabel : null}
                </Typography>
            </>
        )
    }
}

